import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import AgenticAiPage from '../../features/agentic-ai/AgenticAiPage';
 
const AgenticAiRoute = () => (
  <DashboardLayout>
    <AgenticAiPage />
  </DashboardLayout>
);
 
export default AgenticAiRoute;
 